import styled from 'styled-components';
export { Result } from './Result';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1cmee4a-0"
})(["display:block;"]);
export var Results = styled.div.withConfig({
  displayName: "partials__Results",
  componentId: "sc-1cmee4a-1"
})(["display:block;margin-top:8px;margin-bottom:16px;"]);